module.exports = __webpack_public_path__ + "img/coin800.4ff793fe.png";